var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`iq-progress-bar ${_vm.verticle ? 'progress-bar-vertical iq-bg-'+_vm.color : ''}`},[_c('span',{ref:"progress",class:`bg-${_vm.color}`,attrs:{"data-value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }